import { CreatorBrand } from 'constants/brands';
import React, { useCallback, useEffect, useState } from 'react';
import { HeadphonesOutlined } from '@landr/maestro';
import { t } from '@lingui/macro';
import { ActionButtonProps } from 'components/ActionButton/ActionButton';
import { ActionButton } from 'components/ActionButton';
import useExecutionEnvironment from 'hooks/useExecutionEnvironment';
import { useAddSessionToCreator } from 'actions/Creator';

export interface AddSessionToCreatorProps
    extends Omit<
        ActionButtonProps,
        'icon' | 'label' | 'onClick' | 'userAction'
    > {
    sessionGuid?: string;
    interactionSource: string;
    onClick?: () => void;
}

export const AddSessionToCreator: React.FC<AddSessionToCreatorProps> = ({
    onClick,
    sessionGuid,
    interactionSource,
    isLoading,
    ...props
}: AddSessionToCreatorProps) => {
    const [isDisabled, setIsDisabled] = useState<boolean>(false);

    const { isDAWPlugin } = useExecutionEnvironment();

    const { addToCreator } = useAddSessionToCreator(
        sessionGuid,
        interactionSource,
    );

    const handleButtonClick = useCallback(
        (event: React.MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            addToCreator();
            onClick && onClick();
        },
        [onClick, addToCreator],
    );

    useEffect(() => {
        setIsDisabled(!sessionGuid);
    }, [sessionGuid]);

    if (isDAWPlugin) {
        return null;
    }
    return (
        <ActionButton
            aria-label={t`Open in ${CreatorBrand}`}
            label={t`Open in ${CreatorBrand}`}
            isDisabled={isDisabled}
            isLoading={isLoading}
            icon={HeadphonesOutlined}
            onClick={handleButtonClick}
            {...props}
        />
    );
};

export default AddSessionToCreator;
